import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Bind } from 'primeng/bind';
import { Toast } from 'primeng/toast';
import { PrimeTemplate } from 'primeng/api';

@Component({
    selector: 'app-toasts',
    templateUrl: './toasts.component.html',
    styleUrls: ['./toasts.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [Bind, Toast, PrimeTemplate],
})
export class ToastsComponent {}
